export default function ImpactAnalysisProcessDirective() {
  return {
    template: require('./impact-analysis-process.html'),
    scope: {
      process: '=',
    },
    controller: 'ImpactAnalysisProcessController',
    controllerAs: 'impactAnalysisProcessVM',
    bindToController: true,
    replace: true,
  };
}
